$(document).ready(function() {
  $('.product-registration-inner-form').not(':first').hide();

  $('.product-registration-inner-tabtitle').click(function() {
    // $('.product-registration-inner-form').hide();
    $(this).closest('.product-registration-inner').find('.product-registration-inner-form').show();
  });

  $('.product-register-next').click(function() {
    $(this).closest('.product-registration-inner-form').hide();
    $(this).closest('.product-registration-inner').next().find('.product-registration-inner-form').show();
  });

  $('.product-register-next-next').click(function() {
    $(this).closest('.product-registration-inner-form').hide();
    $(this).closest('.product-registration-inner').next().find('.product-registration-inner-form').show();
  });
});








